export const SEND_MESSAGE_RTK_KEY = 'SEND_MESSAGE';
